import React from 'react'
import styles from "../components/laymanComp_css/LaymanPage16.module.css"
import BlockData from "../../../layman-explanation-json/radha_krishna_innocence.json";
import Common_html from './Common_html';
export default function LaymanPage16_radhakrishna_innocence() {
  return (
    <>
    <Common_html BlockData={BlockData} />
    </>
  )
}
